import axios from "axios";
import store from "../store";

class UserActions {

	// test_jwt (optionnel) : jwt d'un utilisateur simulé ("tester en tant que"). Comme
	// database.js, appliqué UNIQUEMENT sur les actions en lecture seule (select/show),
	// jamais sur une action de modification, même si elle est fournie par erreur.
	get(action, table, params, no_actions_sql, test_jwt = null) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			let read_only_actions = ["select", "show"];
			if (test_jwt && read_only_actions.includes(String(action).toLowerCase()))
				jwt = test_jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/user_actions",
					{
						action: action,
						table: table,
						params: params,
						no_actions_sql: no_actions_sql
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new UserActions();
